var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('public-head',{attrs:{"backgroundImage":_vm.bg,"subTitle":"NEWS CENTER","title":"新闻中心","show":true}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }